import React from 'react'
import { Pane, ModalWrapper, ModalHeader, ModalBody, Close } from './styles'

const Modal = ({ children, onClose, width = null }) => {
  return (
    <Pane
      onClick={e => {
        const container = document.getElementById('modal-container')
        if (container && container.contains(e.target)) {
          return
        }

        onClose()
      }}
    >
      <ModalWrapper width={width} id="modal-container">
        <ModalHeader>
          <Close onClick={onClose}>
            <i className="material-icons">close</i>
          </Close>
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
      </ModalWrapper>
    </Pane>
  )
}

export default Modal
